import { Box } from '@mui/material';

import { SearchForm, SearchFormProps } from '@occc/ui-design-system';

const SEARCH_FORM_FIXED_SPACING = 26;

export const TouchpointSearchForm = (props: SearchFormProps) => {
  return (
    <Box
      sx={(theme) => ({
        width: theme.spacing(SEARCH_FORM_FIXED_SPACING),
      })}
    >
      <SearchForm {...props} />
    </Box>
  );
};
